<template lang="pug">
  v-container(fluid)
    v-row
      v-col
        apexchart(
          :options="options"
          :series="options.series"
          :type="options.chart.type"
          :height="options.chart.height"
          :width="options.chart.width"
          class="overflow-hidden"
        )
</template>
<script>
    export default {
        data() {
            return {
                options: {
                    chart: {
                        height: '120px',
                        width: '100%',
                        type: 'line',
                        sparkline: {
                            enabled: true,
                        },
                    },
                    stroke: {
                        curve: 'straight',
                    },
                    fill: {
                        opacity: 0.6,
                    },
                    series: [{
                        data: [227, 388, 149, 422, 273, 344, 199],
                    }],
                    xaxis: {
                        crosshairs: {
                            width: 1,
                        },
                    },
                    yaxis: {
                        min: 0,
                    },
                    title: {
                        text: '$135,965',
                        offsetX: 0,
                        align: 'right',
                        style: {
                            fontSize: '24px',

                            fontFamily: 'Ubuntu',
                            weight: 'bold',
                            color: '#718096',
                        },
                    },
                    subtitle: {
                        text: 'Transactions',
                        offsetX: 0,
                        align: 'right',
                        style: {
                            fontSize: '14px',

                            fontFamily: 'Ubuntu',
                            color: '#718096',
                        },
                    },
                },
            };
        },
    };
</script>
<style lang="scss" scoped>
  .apexcharts-title-text {
    font-weight: bold !important;
  }
  .apexcharts-subtitle-text {
    font-weight: bold;
  }
</style>
